import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './components/Home';
import ArticleDetail from './components/ArticleDetail';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import Footer from './components/Footer';
import About from './components/About';
import Contact from './components/Contact';
import PaymentStatus from './components/PaymentStatus';
import "../src/components/ScrollToTop.css"
import './App.css';

function AppWrapper() {

  // Component to automatically scroll to top on route changes in it.
  function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return null;
  }

  // Scroll to top button component
  function ScrollToTopButton() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
      const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      };

      window.addEventListener("scroll", toggleVisibility);
      return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    };

    return (
      <div className="scroll-to-top">
        {isVisible && (
          <button onClick={scrollToTop} aria-label="Scroll to top">
            <img className="arroww" src="/assets/up-arrow.png" alt="" />
          </button>
        )}
      </div>
    );
  }

  return (
    <>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          {/* <Route path="/article-detail/:id" element={<ArticleDetail />} /> */}
          <Route path="/article-detail/:slug" element={<ArticleDetail />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/withdraw/status" element={<PaymentStatus />} />
        </Routes>
        <Footer />
        <ScrollToTopButton />
      </Router>
    </>
  );
}

export default AppWrapper;